import { useSubscriptions } from "@/api/subscription";
import { Subscription } from "@/api/types";
import useActiveOrg from "./active-org";

export function useActiveSubscription(): {
  subscription: Subscription | null;
  loading: boolean;
} {
  const { org } = useActiveOrg();

  const { data: subscriptions } = useSubscriptions({ org: org?.id });
  const subscription = subscriptions?.[0] ?? null;

  return {
    subscription,
    loading: subscriptions === undefined,
  };
}

export default useActiveSubscription;
